import React from "react";
import "./Textarea.scss";
import classNames from "classnames";

const Textarea = ({label, value, onChange, className, error, description, required}) => {
    const textareaProps = {
        className: classNames({"wrong-input": error}),
        defaultValue: value || "",
        onChange: onChange,
        description
    };

    return (
        <div className={classNames("textarea", className)}>
            <label className={classNames({"required": required})}>{label}</label>
            <div className="textarea-wrapper">
                <textarea {...textareaProps} rows={3}/>
                {description && (
                    <p className="description">{description}</p>
                )}
                {error && (
                    <p>{error}</p>
                )}
            </div>
        </div>
    );
};

export default Textarea;